import { ObjectHelpers } from "../../helpers/object-helpers";

export class BidAskDataModel {
    public bid = 0;
    public ask = 0;
    public bidSize = 0;
    public askSize = 0;    
    public bidParticipantCount = 0;
    public askParticipantCount = 0;
    public bidParticipantSize = 0;
    public askParticipantSize = 0;
    public tradePrice = 0;
    public tradeSize = 0;
    public tradeTime = new Date();
    public quoteTime = new Date();
    public symbol = '';

    constructor(data?: any) {
        if (data) {
            ObjectHelpers.setProperties(data, this, true);
        }
    }
}